import { SVGProps } from 'react';

import theme from '@styles/theme';

export const FilledStarIcon = ({
  width = '24',
  height = '24',
  fill = theme.palette.primary[17],
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill={fill}
      d='m12 1 .464 1.939C12.972 5.062 13.537 7.484 15 9c1.478 1.531 3.862 2.148 5.99 2.726L22 12l-1.01.274C18.862 12.852 16.478 13.47 15 15c-1.463 1.516-2.028 3.938-2.536 6.061L12 23l-.464-1.939C11.028 18.938 10.463 16.516 9 15c-1.478-1.531-3.862-2.148-5.99-2.726L2 12l1.01-.274C5.138 11.148 7.522 10.53 9 9c1.463-1.516 2.028-3.938 2.536-6.061z'
    ></path>
  </svg>
);
